/** Deterministic RNG. Same seed, same sequence. No Math.random. */

export function rngNext(state: number): { state: number; value: number } {
  let s = (Math.imul(state >>> 0, 1664525) + 1013904223) >>> 0;
  if (s === 0) s = 1;
  return { state: s, value: s / 4294967296 };
}

export function normalizeSeed(seed: number): number {
  const s = seed >>> 0;
  return s === 0 ? 1 : s;
}

export function mixSeed(a: number, b: number): number {
  const mixed = (Math.imul((a ^ b) >>> 0, 0x9e3779b1) ^ (a << 13)) >>> 0;
  return mixed === 0 ? 1 : mixed;
}
